// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.template-1-main {
  background-color: #f8fafb;
  border-radius: 16px;
}

.template-1-header .seller-profile .user-profile-pic {
  width: 90px !important;
  height: 90px !important;
  border-radius: 13px;
  margin-right: 10px;
}

.panels {
  height: 370px;
  background: #fff;
  border-radius: 8px 8px 0 0;
}

.panels img {
  height: 100%;
  width: 100%;
}

.topLogo {
  width: -moz-fit-content;
  width: fit-content;
}

.addScroll{
  height: 200px;
  overflow: auto;
}
.removeScroll{
  height: unset !important;
  overflow: unset !important;
}

.seller-profile {
  text-align: center;
}

.profileInfo-section {
  background: #fff;
  border-radius: 0 0 8px 8px;
  height: 322px;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}

.bus-descr {
  font-size: 14px;
  color: #797979;
}

.information {
  font-size: 14px;
  color: #797979;
  font-weight: 500;
  margin-top: 45px;
}

.information p a {
  text-decoration: underline !important;
  color: #797979;
}

.iframe-video {
  border-radius: 8px 8px 0 0;
}

.row-section {
  border-radius: 8px;
  border: 1px solid #E8E8E8;
}

.tab-box-group {
  width: 100%;
  text-align: center;
}

.tab-box-group ul,
.settings-wrapper ul {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  background: white;
}

.tab-box-group ul li,
.settings-wrapper ul li {
  list-style: none;
  font-weight: 500;
  text-wrap: wrap;
  font-size: 14px;
  color: #878395;
  cursor: pointer;
}

.tab-box-group ul li.active,
.settings-wrapper ul li.active {
  border-bottom: 3px solid rgba(108, 47, 187, 1);
  color: rgba(108, 47, 187, 1);
}

.groups-section {
  background: #fff;
  border-radius: 8px;
  border: 1px solid #E8E8E8;
  padding: 15px 24px !important;
}

.next p {
  font-weight: 600;
  text-align: right;
  cursor: pointer;
  margin: 20px;
}

.next p a {
  color: #6c2fbb;
  font-size: 14px;
}

.leftLogo {
  display: flex;
  align-items: center;
  gap: 10px;
}

.rightLogo {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  gap: 10px;
}

.seeMore p a {
  color: #6c2fbb;
  background: #EFE4FF;
  font-size: 12px;
  padding: 4px;
  border-radius: 12px;
}

.next p a:hover {
  text-decoration: none;
}

.line {
  position: relative;
}

.line::after {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 1px;
  background-color: #ccc;
}

.dots {
  top: 0;
  right: 0;
  display: flex;
  cursor: pointer;
  align-items: center;
  -moz-column-gap: 10px;
       column-gap: 10px;
  padding: 7px 16px;
  border-radius: 0 5px;
  color: #6c2fbb;
}

.video-card {
  height: 100%;
  width: 100%;
  border: none;
  position: relative;
  display: flex;
  justify-content: center;
}

.video-card img {
  position: relative;
  border-radius: 15px;
  height: 100%;
  min-height: 110px;
  object-fit: fill;
}

.video-card p {
  position: absolute;
  bottom: 0;
  background: #00000099;
  color: white;
  margin: 0;
  width: 100%;
  text-align: center;
  padding: 2px 20px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
}

.cursor {
  cursor: pointer;
}

.set-top-logo {
  position: absolute;
  top: 320px;
  left: 24px;
}

.editIcon {
  position: absolute;
  right: 20px;
  top: 15px;
  cursor: pointer;
}

.allGroups {
  height: 100%;
  overflow: auto;
  max-height: 550px;
}

/* ============= */
.rag-body {
  max-height: 80vh;
  overflow: auto;
}
.rag-list.cdk-drop-list-dragging .rag-box:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.rag-list {
  width: 500px;
  max-width: 100%;
  border: solid 1px #ccc;
  min-height: 60px;
  display: block;
  background: white;
  border-radius: 4px;
  overflow: hidden;
}
.rag-box {
  padding: 10px;
  border-bottom: solid 1px #ccc;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  background: white;
  font-size: 14px;
  z-index: 99999;
}

.rag-box:last-child {
  border: none;
}
.rag-custom-placeholder {
  background: #ccc;
  border: dotted 3px #999;
  min-height: 110px;
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.rag-img-box {
  width: 100px;
  height: 80px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  border-radius: 8px;
  background: #f8f9fa;
}

.rag-img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}

.card .card-badge {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: #727272;
  color: #fff;
  padding: 3px 8px;
  border-radius: 15px 0 7px 0;
}

@media (max-width: 1199px) {
  .mobile-view-name {
    text-align: center;
    justify-content: center;
  }

  .panels {
    margin-bottom: 10px;
  }

  .topBusinessName {
    justify-content: center;
    align-items: center;
  }
}

@media (max-width: 1024px) {
  .video-card .card {
    width: 100% !important;
  }
  .video-card img {
    height: 155px;
}
}

@media (max-width: 768px) {

  .topBusinessName {
    justify-content: center;
    align-items: center;
  }
}

@media (max-width: 430px) {
  .template-1-header {
    padding: 18px 0;
  }

  .panels {
    height: 200px;
  }

  .set-top-logo {
    top: 172px;
  }

  .editIcon {
    top: 38% !important;
  }

  .editIcon p {
    width: 20px;
  }
}

@media (max-width: 425px) {

  .video-card img {
    height: 190px;
}

.title-modern{
  font-size: 14px;
}

.template-1-header .seller-profile .user-profile-pic {
  width: 55px !important;
  height: 55px !important;
  border-radius: 13px;
  margin-right: 10px;
}
}


@media only screen and (max-width: 1440px) and (min-width: 1200px)  {
  .community-access-row .col-xl-7{
      flex: 0 0 83.333333%;
      max-width: 83.333333%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/main-community/modern-template/modern-template.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,8CAA8C;EAC9C,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,QAAQ;EACR,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,MAAM;EACN,QAAQ;EACR,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,qBAAgB;OAAhB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,sDAAsD;AACxD;AACA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,sDAAsD;AACxD;AACA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;AACjB;AACA;;AAEA;;EAEE;IACE,uBAAuB;IACvB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;EAEE;IACE,aAAa;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;;AAGA;EACE;MACI,oBAAoB;MACpB,qBAAqB;EACzB;AACF","sourcesContent":[".template-1-main {\n  background-color: #f8fafb;\n  border-radius: 16px;\n}\n\n.template-1-header .seller-profile .user-profile-pic {\n  width: 90px !important;\n  height: 90px !important;\n  border-radius: 13px;\n  margin-right: 10px;\n}\n\n.panels {\n  height: 370px;\n  background: #fff;\n  border-radius: 8px 8px 0 0;\n}\n\n.panels img {\n  height: 100%;\n  width: 100%;\n}\n\n.topLogo {\n  width: fit-content;\n}\n\n.addScroll{\n  height: 200px;\n  overflow: auto;\n}\n.removeScroll{\n  height: unset !important;\n  overflow: unset !important;\n}\n\n.seller-profile {\n  text-align: center;\n}\n\n.profileInfo-section {\n  background: #fff;\n  border-radius: 0 0 8px 8px;\n  height: 322px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  position: relative;\n}\n\n.bus-descr {\n  font-size: 14px;\n  color: #797979;\n}\n\n.information {\n  font-size: 14px;\n  color: #797979;\n  font-weight: 500;\n  margin-top: 45px;\n}\n\n.information p a {\n  text-decoration: underline !important;\n  color: #797979;\n}\n\n.iframe-video {\n  border-radius: 8px 8px 0 0;\n}\n\n.row-section {\n  border-radius: 8px;\n  border: 1px solid #E8E8E8;\n}\n\n.tab-box-group {\n  width: 100%;\n  text-align: center;\n}\n\n.tab-box-group ul,\n.settings-wrapper ul {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: center;\n  background: white;\n}\n\n.tab-box-group ul li,\n.settings-wrapper ul li {\n  list-style: none;\n  font-weight: 500;\n  text-wrap: wrap;\n  font-size: 14px;\n  color: #878395;\n  cursor: pointer;\n}\n\n.tab-box-group ul li.active,\n.settings-wrapper ul li.active {\n  border-bottom: 3px solid rgba(108, 47, 187, 1);\n  color: rgba(108, 47, 187, 1);\n}\n\n.groups-section {\n  background: #fff;\n  border-radius: 8px;\n  border: 1px solid #E8E8E8;\n  padding: 15px 24px !important;\n}\n\n.next p {\n  font-weight: 600;\n  text-align: right;\n  cursor: pointer;\n  margin: 20px;\n}\n\n.next p a {\n  color: #6c2fbb;\n  font-size: 14px;\n}\n\n.leftLogo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.rightLogo {\n  display: flex;\n  align-items: center;\n  flex-direction: row-reverse;\n  gap: 10px;\n}\n\n.seeMore p a {\n  color: #6c2fbb;\n  background: #EFE4FF;\n  font-size: 12px;\n  padding: 4px;\n  border-radius: 12px;\n}\n\n.next p a:hover {\n  text-decoration: none;\n}\n\n.line {\n  position: relative;\n}\n\n.line::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: 1px;\n  background-color: #ccc;\n}\n\n.dots {\n  top: 0;\n  right: 0;\n  display: flex;\n  cursor: pointer;\n  align-items: center;\n  column-gap: 10px;\n  padding: 7px 16px;\n  border-radius: 0 5px;\n  color: #6c2fbb;\n}\n\n.video-card {\n  height: 100%;\n  width: 100%;\n  border: none;\n  position: relative;\n  display: flex;\n  justify-content: center;\n}\n\n.video-card img {\n  position: relative;\n  border-radius: 15px;\n  height: 100%;\n  min-height: 110px;\n  object-fit: fill;\n}\n\n.video-card p {\n  position: absolute;\n  bottom: 0;\n  background: #00000099;\n  color: white;\n  margin: 0;\n  width: 100%;\n  text-align: center;\n  padding: 2px 20px;\n  border-bottom-left-radius: 15px;\n  border-bottom-right-radius: 15px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 14px;\n}\n\n.cursor {\n  cursor: pointer;\n}\n\n.set-top-logo {\n  position: absolute;\n  top: 320px;\n  left: 24px;\n}\n\n.editIcon {\n  position: absolute;\n  right: 20px;\n  top: 15px;\n  cursor: pointer;\n}\n\n.allGroups {\n  height: 100%;\n  overflow: auto;\n  max-height: 550px;\n}\n\n/* ============= */\n.rag-body {\n  max-height: 80vh;\n  overflow: auto;\n}\n.rag-list.cdk-drop-list-dragging .rag-box:not(.cdk-drag-placeholder) {\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n.rag-list {\n  width: 500px;\n  max-width: 100%;\n  border: solid 1px #ccc;\n  min-height: 60px;\n  display: block;\n  background: white;\n  border-radius: 4px;\n  overflow: hidden;\n}\n.rag-box {\n  padding: 10px;\n  border-bottom: solid 1px #ccc;\n  color: rgba(0, 0, 0, 0.87);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  cursor: move;\n  background: white;\n  font-size: 14px;\n  z-index: 99999;\n}\n\n.rag-box:last-child {\n  border: none;\n}\n.rag-custom-placeholder {\n  background: #ccc;\n  border: dotted 3px #999;\n  min-height: 110px;\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n.rag-img-box {\n  width: 100px;\n  height: 80px;\n  margin-right: 10px;\n  display: flex;\n  justify-content: center;\n  border-radius: 8px;\n  background: #f8f9fa;\n}\n\n.rag-img {\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n}\n\n.card .card-badge {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  background-color: #727272;\n  color: #fff;\n  padding: 3px 8px;\n  border-radius: 15px 0 7px 0;\n}\n\n@media (max-width: 1199px) {\n  .mobile-view-name {\n    text-align: center;\n    justify-content: center;\n  }\n\n  .panels {\n    margin-bottom: 10px;\n  }\n\n  .topBusinessName {\n    justify-content: center;\n    align-items: center;\n  }\n}\n\n@media (max-width: 1024px) {\n  .video-card .card {\n    width: 100% !important;\n  }\n  .video-card img {\n    height: 155px;\n}\n}\n\n@media (max-width: 768px) {\n\n  .topBusinessName {\n    justify-content: center;\n    align-items: center;\n  }\n}\n\n@media (max-width: 430px) {\n  .template-1-header {\n    padding: 18px 0;\n  }\n\n  .panels {\n    height: 200px;\n  }\n\n  .set-top-logo {\n    top: 172px;\n  }\n\n  .editIcon {\n    top: 38% !important;\n  }\n\n  .editIcon p {\n    width: 20px;\n  }\n}\n\n@media (max-width: 425px) {\n\n  .video-card img {\n    height: 190px;\n}\n\n.title-modern{\n  font-size: 14px;\n}\n\n.template-1-header .seller-profile .user-profile-pic {\n  width: 55px !important;\n  height: 55px !important;\n  border-radius: 13px;\n  margin-right: 10px;\n}\n}\n\n\n@media only screen and (max-width: 1440px) and (min-width: 1200px)  {\n  .community-access-row .col-xl-7{\n      flex: 0 0 83.333333%;\n      max-width: 83.333333%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
